import React from 'react';

function Loading() {
  return (
    <div className='loading'>
      <h1>Loading...</h1>
    </div>
  );
}

export default Loading;
